.action{cursor:pointer;padding:3px 7px;width:100%}
/*# sourceMappingURL=coverage-table-actions-renderer.component-KS7S5R6K.css.map */
